// Pagination
export const PAGE_SIZE_OPTIONS = [25, 50, 100, 200];
export const DEFAULT_PAGE_SIZE = PAGE_SIZE_OPTIONS[0];

// Column widths
export const COLUMN_WIDTHS = {
  NAME: 250,
  STUDENT_ID: 150,
  COURSE_TOTAL: 140,
  ASSIGNMENT: 180,
  CATEGORY_TOTAL: 180,
};

// Sticky column configuration
export const STICKY_COLUMN_WIDTH = COLUMN_WIDTHS.NAME;

// Row dimensions
export const ROW_HEIGHT = 50;

// Header row indices - the three header rows live above the data rows, which
// start at 0, so they use negative indices.
export const ROW_INDEX = {
  CATEGORY: -3,
  ASSIGNMENT: -2,
  AVERAGE: -1,
};
export const MIN_ROW_INDEX = ROW_INDEX.CATEGORY;

// Virtualization settings
export const VIRTUALIZER_OVERSCAN = {
  ROWS: 10,
  COLUMNS: 5,
};

// Scroll/focus behavior
export const STICKY_HEADER_HEIGHT = 150;
export const SCROLL_PADDING = 20;

// Debounce delays (ms)
export const AVERAGES_FETCH_DEBOUNCE = 400;
